import React from "react";
import { ICalc, IEmpresa } from "../../model";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";

/**
 * Gera as opções de cálculo com base nas condições do tipo e modelo fornecidos.
 * 
 * A função filtra os cálculos disponíveis de acordo com as condições da empresa, como
 * regime tributário (Simples Nacional, Simples Nacional com excesso, Regime Especial ICMS PA),
 * e o tipo de cálculo especificado. O retorno é uma lista de cálculos que atendem aos critérios
 * da empresa e das configurações fornecidas.
 *
 * @param calcs - Lista de cálculos disponíveis a serem filtrados.
 * @param tmp_tipo - Tipo de cálculo a ser considerado (por exemplo, "entrada", "saida").
 * @param tmp_modelo - Modelo de cálculo a ser considerado (por exemplo, "nfe", "cte", "nfce", "nfse").
 * 
 * @returns Array de cálculos filtrados conforme as condições da empresa.
 */
export function GenerateCalcOptions(calcs: any[], tmp_tipo: string, tmp_modelo: string, empresa: IEmpresa) {

  let calc_options: any = []

  calc_options = calcs?.map((calc: ICalc) => {

    if (calc[tmp_tipo] && calc[tmp_modelo]) {

      const { simples_nacional, simples_nacional_excesso, regime_e_sem_regime, regime_especial } = calc;

      if (empresa.simples_nacional && empresa.simples_nacional_excesso && empresa.regime_especial_icms_pa) {

        /** Carregar cálculos que atendem simples_nacional && simples_nacional_excesso */
        if (simples_nacional && simples_nacional_excesso) {
          return calc
        }

        /** Carregar cálculos que atendem regime_especial */
        if (regime_especial) {
          return calc
        }

        /** Carregar cálculos que atendem regime_e_sem_regime */
        if (regime_e_sem_regime) {
          return calc
        }

      }

      /** Empresa Simples Nacional sem excesso */
      if (empresa.simples_nacional && !empresa.simples_nacional_excesso && simples_nacional && !simples_nacional_excesso) {
        return calc
      }

      /** Empresa Simples Nacional com excesso */
      if (empresa.simples_nacional && empresa.simples_nacional_excesso && simples_nacional && simples_nacional_excesso) {
        return calc
      }

      /** Empresa com regime especial */
      if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && empresa.regime_especial_icms_pa && (regime_e_sem_regime || regime_especial)) {
        return calc
      }

      /** Outros casos gerais para regime sem regime especial */
      if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && !empresa.regime_especial_icms_pa && regime_e_sem_regime && !regime_especial) {
        return calc
      }

    }

    /** Cálculo não econtrado */
    return null;

  });

  return calc_options.filter(option => option !== null);

}

export function ReturnCalcsEmpresa(calcs: any[], empresa: IEmpresa) {

  let calc_options: any = []

  calc_options = calcs?.map((calc: ICalc) => {

    const { simples_nacional, simples_nacional_excesso, regime_e_sem_regime, regime_especial } = calc;

    if (empresa.simples_nacional && empresa.simples_nacional_excesso && empresa.regime_especial_icms_pa) {

      /** Carregar cálculos que atendem simples_nacional && simples_nacional_excesso */
      if (simples_nacional && simples_nacional_excesso) {
        return calc
      }

      /** Carregar cálculos que atendem regime_especial */
      if (regime_especial) {
        return calc
      }

      /** Carregar cálculos que atendem regime_e_sem_regime */
      if (regime_e_sem_regime) {
        return calc
      }

    }

    /** Empresa Simples Nacional sem excesso */
    else if (empresa.simples_nacional && !empresa.simples_nacional_excesso && simples_nacional && !simples_nacional_excesso) {
      return calc
    }

    /** Empresa Simples Nacional com excesso */
    else if (empresa.simples_nacional && empresa.simples_nacional_excesso && simples_nacional && simples_nacional_excesso) {
      return calc
    }

    /** Empresa com regime especial */
    else if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && empresa.regime_especial_icms_pa && (regime_e_sem_regime || regime_especial)) {
      return calc
    }

    /** Outros casos gerais para regime sem regime especial */
    else if (!empresa.simples_nacional && !empresa.simples_nacional_excesso && !empresa.regime_especial_icms_pa && regime_e_sem_regime && !regime_especial) {
      return calc
    }

    return null;

  }).filter(item => item !== null);

  return calc_options;

}